import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const PageHeading: React.FC = () => {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <motion.p 
        className="text-[#181411] dark:text-white text-4xl font-black leading-tight tracking-[-0.033em]"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        {t('dashboard.heading')}
      </motion.p>
    </motion.div>
  );
};

export default PageHeading;